import { render, staticRenderFns } from "./DanceIllustration.vue?vue&type=template&id=262a4cb6"
import script from "./DanceIllustration.vue?vue&type=script&lang=js"
export * from "./DanceIllustration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports